'use client';

import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import TrustSection from './components/TrustSection';
import PaymentSection from './components/PaymentSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import LegalModal from './components/LegalModal';
import CookieBanner from './components/CookieBanner';

type LegalType = 'privacy' | 'terms' | 'refund' | 'delivery' | null;

export default function HomepageInteractive() {
  const [legalModal, setLegalModal] = useState<LegalType>(null);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <TrustSection />
        <PaymentSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer onLegalClick={(type) => setLegalModal(type)} />
      <LegalModal type={legalModal} onClose={() => setLegalModal(null)} />
      <CookieBanner />
    </>
  );
}